import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "taskpane" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_5 = {
  key: 1,
  class: "status"
}
const _hoisted_6 = {
  key: 2,
  class: "info-banner"
}
const _hoisted_7 = {
  class: "status",
  role: "status",
  "aria-live": "polite"
}

import { computed, ref, watch } from 'vue';
import TagPicker from './components/TagPicker.vue';
import DocumentCheckPanel from './components/DocumentCheckPanel.vue';
import { fetchSupportedTags } from '@/services/api';
import {
  DocumentTemplateSourceType,
  sourceTypeLabels,
  type SupportedTags,
} from '@/types/SupportedTags';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const sourceType = ref<DocumentTemplateSourceType>(DocumentTemplateSourceType.Contract);
const tags = ref<SupportedTags | null>(null);
const loading = ref(false);
const error = ref<string | null>(null);
const status = ref<string>('');

const sourceTypeOptions = [
  { value: DocumentTemplateSourceType.Contract, title: sourceTypeLabels[DocumentTemplateSourceType.Contract] },
  { value: DocumentTemplateSourceType.SpecHome, title: sourceTypeLabels[DocumentTemplateSourceType.SpecHome] },
  { value: DocumentTemplateSourceType.ChangeOrder, title: sourceTypeLabels[DocumentTemplateSourceType.ChangeOrder] },
];

const isEmpty = computed(
  () => !!tags.value && tags.value.fieldTags.length === 0 && tags.value.groups.length === 0,
);

async function load(type: DocumentTemplateSourceType): Promise<void> {
  loading.value = true;
  error.value = null;
  try {
    tags.value = await fetchSupportedTags(type);
  } catch (e) {
    error.value = e instanceof Error
      ? 'Unable to load tag list. Check your internet connection and try again.'
      : String(e);
    tags.value = null;
  } finally {
    loading.value = false;
  }
}

watch(sourceType, (v) => void load(v), { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", null, "Template Builder")
    ], -1 /* CACHED */)),
    _cache[4] || (_cache[4] = _createElementVNode("label", {
      class: "field-label",
      for: "source-type"
    }, "Source type", -1 /* CACHED */)),
    _withDirectives(_createElementVNode("select", {
      id: "source-type",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sourceType).value = $event)),
      class: "picker",
      disabled: loading.value
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sourceTypeOptions, (option) => {
        return _createElementVNode("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.title), 9 /* TEXT, PROPS */, _hoisted_3)
      }), 64 /* STABLE_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_2), [
      [
        _vModelSelect,
        sourceType.value,
        void 0,
        { number: true }
      ]
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(error.value) + " ", 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "link-btn",
            onClick: _cache[1] || (_cache[1] = () => load(sourceType.value))
          }, "Retry")
        ]))
      : (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading tags…"))
        : (isEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No tags supported yet for this source type. Its mapper is on the roadmap. "))
          : (tags.value)
            ? (_openBlock(), _createBlock(TagPicker, {
                key: 3,
                tags: tags.value,
                onInsertStatus: _cache[2] || (_cache[2] = ($event: any) => (status.value = $event))
              }, null, 8 /* PROPS */, ["tags"]))
            : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_7, _toDisplayString(status.value), 1 /* TEXT */),
    (tags.value)
      ? (_openBlock(), _createBlock(DocumentCheckPanel, {
          key: 4,
          tags: tags.value
        }, null, 8 /* PROPS */, ["tags"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})